import { Button, Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import { channelById } from '../../../constants/Channels'
import ExternalChannelLink from '../../ExternalChannelLink'
import GridSquare from '../GridSquare'
import { OrderDetails } from '../orders/OrderDetails'
import NiceListingStatus from '../../NiceListingStatus'
import ActionBar from './ActionBar'
import Header from './Header'
import ItemDetails from './ItemDetails'
import ListingStrategyRunDetails from './ListingStrategyRunDetails'
import { ListingSequence } from './ListingSequence'
import ProductDetails from './ProductDetails'
import ProductListings from './ProductListings'

const Renderer = ({
  listing,
  product,
  productListings,
  channelId,
  children,
  onClose,
  onProductListingClick,
  onRelist,
  onDelist,
  onRecycle,
  onDelete,
  onList,
  onListingStrategyChange
}) => {
  const channel = channelById(channelId)
  return (
    <div className="product-drawer">
      <div className="close">
        <Button minimal onClick={onClose}>
          <Icon icon={IconNames.CROSS} iconSize={25} />
        </Button>
      </div>
      <Header listing={listing} product={product} />
      <ProductDetails product={product} />

      <OrderDetails product={product} />

      <ItemDetails>
        <GridSquare
          title="Channel"
          contents={listing.marketAccount ? listing.marketAccount.fullHumanReadableName : channel.humanReadableName}
        />

        <GridSquare
          title="Channel ID"
          contents={
            listing.externalMarketId && (
              <div style={{ display: 'inline-block' }}>
                <ExternalChannelLink
                  channel={channel.name}
                  id={listing.externalMarketId}
                  listingUrl={listing.listingUrl}
                />
              </div>
            )
          }
        />
        <GridSquare
          title="Status"
          contents={
            <NiceListingStatus
              value={listing.state}
              errors={listing[channel.errorKey]}
              message={channel.name === 'ebay' ? listing.ebayMessage : null}
            />
          }
        />

        {children}
      </ItemDetails>
      {product.isMedia && product.isRepricingPaused === false ? <ListingSequence /> : null}
      {product.listingStrategyRun && product.isRepricingPaused ? (
        <ListingStrategyRunDetails
          listingStrategyRun={product.listingStrategyRun}
          listingStrategyId={product.listingStrategyId}
          productId={product.id}
          onChange={onListingStrategyChange}
          overridesActive={!!product.overriddenValues}
        />
      ) : null}
      <ProductListings
        productListings={productListings}
        currentListingId={listing.id}
        channelId={channelId}
        onCardClick={onProductListingClick}
      />
      <ActionBar
        product={product}
        listing={listing}
        channelId={channelId}
        onList={onList}
        onDelist={onDelist}
        onRelist={onRelist}
        onRecycle={onRecycle}
        onDelete={onDelete}
      />
    </div>
  )
}

export default Renderer
